















export default

	props:
		item: Object
		contentMap: Object
		full: Boolean
		regionClick: Boolean
		traceData: Object

	computed:
		isAvocado: -> @traceData?.ItemDesc?.includes "Avo" or false
		isLucini: -> @traceData?.ItemDesc?.includes "Lucini" or false

		widthClasses: -> [
			'full' if @full
		]

		flavored: ->
			if @contentMap?.flavored then return true
			else return false

		showCell3: ->
			if @flavored || @isAvocado then return false
			return true

	methods:
		onClick: (label) -> @$emit 'clicked', label

